import { Buttons } from "@/pages/Home/ui/Application/ui/Buttons";
import { Header } from "@/pages/Home/ui/Application/ui/Header";
import { Steps } from "@/pages/Home/ui/Application/ui/Steps";

export function Application() {
  return (
    <section className="lgc:mt-22 lgc:bg-brand-light mt-10 px-4">
      <div className="lgc:flex-row relative container flex gap-8">
        <div className="desktop-display flex-1">
          <img
            className="absolute bottom-0"
            src="/static/images/men-woman-1.webp"
            alt="factor plus application"
          />
        </div>
        <div className="flex-col-gap-6 lgc:gap-10 lgc:py-14 flex-1">
          <Header />
          <Steps className="lgc:grid hidden" />
          <Buttons />
          <div className="mobile-display flex flex-col">
            <img
              src="/static/images/men-woman-1.webp"
              alt="factor plus application"
            />
            <Steps />
          </div>
        </div>
      </div>
    </section>
  );
}
